import { render, staticRenderFns } from "./UnsupportView.vue?vue&type=template&id=6bd53a07&scoped=true&"
import script from "./UnsupportView.vue?vue&type=script&lang=ts&"
export * from "./UnsupportView.vue?vue&type=script&lang=ts&"
import style0 from "./UnsupportView.vue?vue&type=style&index=0&id=6bd53a07&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd53a07",
  null
  
)

export default component.exports